/**
 * Used across Trello to decide whether Jira site linking details should be displayed
 * to the user.  Currently there are no cases where we want to do this.
 * @param orgId
 * @returns
 */
// eslint-disable-next-line @eslint-react/hooks-extra/no-unnecessary-use-prefix
export const useShouldHideLinkingDetails = (orgId?: string): boolean => {
  return false;
};
